"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.treeStructure = exports.recursiveFindKey = exports.batchReplace = exports.toFixed = exports.hasOwnProperty = exports.forceToBoolean = exports.isEmptyArray = exports.isEmptyObject = exports.isBoolean = exports.isInt = exports.isSet = exports.isMap = exports.isSymbol = exports.isFunction = exports.isUndefined = exports.isArray = exports.isObject = exports.isString = exports.isNumber = exports.getType = exports.shallowDiff = exports.deepDiff = exports.toggleClass = void 0;
var lodash_1 = require("lodash");
/**
 * @description 自动添加移除className
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {string | string[]} classNameList | className集合
 * @param {string} className | 类名字符串 仅支持单个类名 多个无效
 * @returns {string} string 返回处理好的className
 * @example
 * toggleClass(['index', 'page'], 'active')  //return  => 'index page active'
 * toggleClass(['index', 'page', 'remove'], 'remove')  //return  => 'index page'
 * toggleClass('index page', 'active')  //return  => 'index page active'
 * toggleClass('index page remove', 'remove')  //return  => 'index page'
 */
var toggleClass = function (classNameList, className) {
    if (exports.isString(classNameList)) {
        classNameList = classNameList.split(' ');
    }
    var isRemove = false;
    classNameList = classNameList.map(function (classItem) {
        if (classItem === className) {
            isRemove = true;
            return '';
        }
        return classItem;
    }).filter(function (item) { return !!item; });
    // isRemove表示是否移除
    classNameList = isRemove ? classNameList : __spreadArray(__spreadArray([], classNameList), [className]);
    return classNameList.join(' ');
};
exports.toggleClass = toggleClass;
/**
 * @description 对数据进行深度比较 可以配合React.memo使用 [React.memo默认浅比较 只对比引用]
 *
 * 概念
 * 浅比较 只检查左右两边是否是同一个对象的引用
 * 深比较 只检查两个对象的所有属性是否都相等 不管这两个对象是不是同一对象的引用
 *
 * 关于性能
 * 深比较需要以递归的方式遍历两个对象的所有属性，操作比较耗时 如非必要 不建议调用此方法
 *
 * 手写的部分因过于臃肿已经删除 替换为lodash中的isEqual
 * 详情见文档 https://www.lodashjs.com/docs/lodash.isEqual
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {V} value 数据源
 * @param {O} other 其他数据源
 * @returns {boolean} true | false 两组数据是否相等
 */
var deepDiff = function (value, other) {
    return lodash_1.isEqual(value, other);
};
exports.deepDiff = deepDiff;
/**
 * @description 对数据进行浅度比较 对于不同引用地址的 Object和Array 必定返回false
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {V} value 数据源
 * @param {O} other 其他数据源
 * @returns {boolean} true | false 两组数据是否相等
 */
var shallowDiff = function (value, other) {
    return Object.is(value, other);
};
exports.shallowDiff = shallowDiff;
/**
 * @description 获取数据类型 未能识别的会返回 unknown
 * 特别注意：这是一个实验性的方法 请调用 isString isArray等方法来检测类型
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {T} target  数据源
 * @returns {string} string
 */
var getType = function (target) {
    var key = Object.prototype.toString.call(target);
    switch (key) {
        case '[object Number]':
            return 'number';
        case '[object String]':
            return 'string';
        case '[object Boolean]':
            return 'boolean';
        case '[object Object]':
            return 'object';
        case '[object Array]':
            return 'array';
        case '[object Null]':
            return 'null';
        case '[object Undefined]':
            return 'undefined';
        case '[object Function]':
            return 'function';
        case '[object Symbol]':
            return 'symbol';
        case '[object Map]':
            return 'map';
        case '[object Set]':
            return 'set';
        default:
            return 'unknown';
    }
};
exports.getType = getType;
/**
 * @description 检测数据是否为number
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isNumber = function (target) {
    return exports.getType(target) === 'number' && typeof target === 'number';
};
exports.isNumber = isNumber;
/**
 * @description 检测数据是否为string
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isString = function (target) {
    return exports.getType(target) === 'string' && typeof target === 'string';
};
exports.isString = isString;
/**
 * @description 检测数据是否为object
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isObject = function (target) {
    return exports.getType(target) === 'object' && typeof target === 'object';
};
exports.isObject = isObject;
/**
 * @description 检测数据是否为array
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isArray = function (target) {
    return exports.getType(target) === 'array' && Array.isArray(target);
};
exports.isArray = isArray;
/**
 * @description 检测数据是否为undefined
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isUndefined = function (target) {
    return exports.getType(target) === 'undefined' && typeof target === 'undefined';
};
exports.isUndefined = isUndefined;
/**
 * @description 检测数据是否为function
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isFunction = function (target) {
    return exports.getType(target) === 'function' && typeof target === 'function';
};
exports.isFunction = isFunction;
/**
 * @description 检测数据是否为Symbol
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isSymbol = function (target) {
    return exports.getType(target) === 'symbol' && typeof target === 'symbol';
};
exports.isSymbol = isSymbol;
/**
 * @description 检测数据是否为Map
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isMap = function (target) {
    return exports.getType(target) === 'map';
};
exports.isMap = isMap;
/**
 * @description 检测数据是否为Set
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isSet = function (target) {
    return exports.getType(target) === 'set';
};
exports.isSet = isSet;
/**
 * @description 检测数据是否为int
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isInt = function (target) {
    return Number.isInteger(target);
};
exports.isInt = isInt;
/**
 * @description 检测数据是否为int
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {unknown} target 数据源
 * @returns {boolean} true | false
 */
var isBoolean = function (target) {
    return exports.getType(target) === 'boolean' && typeof target === 'boolean';
};
exports.isBoolean = isBoolean;
/**
 * @description 检测数据是否为是空对象 如果传入的是一个数组 将会检测是否是一个空数组
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {object} target 数据源
 * @returns {boolean} true | false
 */
var isEmptyObject = function (target) {
    if (exports.isArray(target)) {
        return exports.isEmptyArray(target);
    }
    return !exports.forceToBoolean(Object.keys(target).length);
};
exports.isEmptyObject = isEmptyObject;
/**
 * @description 检测数据是否为是空数组
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {T extends { length: number }} target 数据源
 * @returns {boolean} true | false
 */
var isEmptyArray = function (target) {
    return !exports.forceToBoolean(target.length);
};
exports.isEmptyArray = isEmptyArray;
/**
 * @description 将数据强制转换为布尔类型
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {T} target 数据源
 * @returns {boolean} true | false
 */
var forceToBoolean = function (target) {
    return !!target;
};
exports.forceToBoolean = forceToBoolean;
/**
 * @description 使用原型上的方法检测该对象上是否存在指定的属性 是为了防止hasOwnProperty被重写
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {S} source 源对象
 * @param {string} key 属性key值
 * @returns {boolean} true | false
 */
var hasOwnProperty = function (source, key) {
    return Object.prototype.hasOwnProperty.call(source, key);
};
exports.hasOwnProperty = hasOwnProperty;
/**
 * @description 保留为小数点后N位 传入的参数必须为number 或string类型的数字 否则会直接返回源对象
 * ```Number.prototype.toFixed``` 由于使用的是使用的是银行家舍入规则 部分情况会导致结果异常
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {S = number | string} source 传入的字符串或数字
 * @param {string} fractionDigits 保留小数的位数 默认2位
 * @returns {string} string
 * @example
 * toFixed(11, 3); //return  => 11.000
 * toFixed('12', 3); //return  => 12.000
 * toFixed('12.3355', 2); //return  => 12.34
 */
var toFixed = function (source, fractionDigits) {
    if (fractionDigits === void 0) { fractionDigits = 2; }
    if (!exports.isNumber(source) && !exports.isString(source)) {
        return source;
    }
    return Number(source).toFixed(fractionDigits + 1).slice(0, -1);
};
exports.toFixed = toFixed;
/**
 * @description 批量替换字符串 传入数据源必须是字符串 否则会直接返回源对象
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {(string | RegExp)[]} searchArray 要寻找的内容-数组
 * @param {string[]} replaceArray 要替换的内容-数组
 * @param {string} source 传入的字符串
 * @param {boolean} isGlobal 是否开启全局查找 默认false 如果开启此项searchArray中使用的正则需要使用```/g```修饰符匹配否则将会抛出异常
 * @returns {string} string 替换完成的字符串
 * @example
 * batchReplace(['张三丰', '令狐冲', '独孤九剑'], ['张三', '李四', '王五'], '张三丰1号和张三丰2号问令狐冲的独孤九剑练的怎么样了，独孤九剑问张三丰为什么要练我？');  return '张三1号和张三丰2号问李四的王五练的怎么样了，独孤九剑问张三丰为什么要练我？';
 * batchReplace(['张三丰', '令狐冲', '独孤九剑'], ['张三', '李四', '王五'], '张三丰1号和张三丰2号问令狐冲的独孤九剑练的怎么样了，独孤九剑问张三丰为什么要练我？', true);  return '张三1号和张三2号问李四的王五练的怎么样了，王五问张三为什么要练我？';
 * batchReplace(['张三丰', /\S{1}狐冲/g, '独孤九剑'], ['张三', '李四', '王五'], '张三丰1号和张三丰2号问令狐冲的独孤九剑练的怎么样了，独孤九剑问张三丰为什么要练我？', true); return '张三1号和张三2号问李四的王五练的怎么样了，王五问张三为什么要练我？';
 */
var batchReplace = function (searchArray, replaceArray, source, isGlobal) {
    if (isGlobal === void 0) { isGlobal = false; }
    if (searchArray.length !== replaceArray.length) {
        return source;
    }
    searchArray.forEach(function (v, i) {
        if (isGlobal) {
            source = source.replaceAll(v, replaceArray[i]);
        }
        else {
            source = source.replace(v, replaceArray[i]);
        }
    });
    return source;
};
exports.batchReplace = batchReplace;
/**
 * @description 对传入的对象进行循环 检测到searchKeyArray中存在的key时执行callback
 *
 * 这是一个开放性的方法 后期可以用于解决递归替换key等操作
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {T extends object} source 数据源
 * @param {S extends keyof T} searchKeyArray 要搜索的key-数组
 * @param {<V>(source: T, value: T[S], key: keyof T) => void} callback 回调方法 source=当前处理的对象 value=当前匹配到的value key=当前查找到的key
 * @returns {void} void
 * @example
 *  const obj = { name: '张三丰', age: '18', sex: 1, status: 121 };
 *  recursiveFindKey(obj, ['sex', 'status'], (o, v, k) => {
 *      if (k === 'sex') {
 *          Reflect.set(o, 'sex_a', v ? '男' : '女');
 *      } else {
 *          Reflect.deleteProperty(obj, k)
 *      }
 *  });
 */
var recursiveFindKey = function (source, searchKeyArray, callback) {
    // todo 找到对象中的那个key然后执行callback(key)
    searchKeyArray.forEach(function (k) {
        var value = source[k];
        if (value) {
            callback(source, value, k);
        }
    });
};
exports.recursiveFindKey = recursiveFindKey;
/**
 * @description 将普通数据转换为树形结构 无限层级
 * @author bugfix2019
 * @email liuyuxuan@inmyshow.com | ts02315607@163.com
 * @param {T extends object} source 数据源
 * @param {keyof T} primaryKey 主键key 一般是id
 * @param {keyof T} parentKey 标识父级关系的key
 * @param {keyof T} parentValue 标识父级关系key的值
 * @param {string} childrenKey 将子元素插入到指定的key中 默认children 有些组件可能要求child
 * @param {callback?: (item: T) => void} callback 如果您想要在转换树形结构时对现有数据需要进行自定义处理 可以使用此custom callback来实现 该方法会传入当前正在处理的item作为参数 可配合recursiveFindKey使用
 * @returns {T[]} T[] 树形结构
 * @example
 * const data = [
 *     { id: 1, pid: 0, name: 'a1', lst: 1 },
 *     { id: 2, pid: 0, name: 'a2', lst: 3 },
 *     { id: 3, pid: 0, name: 'a3', lst: 6 },
 *     { id: 4, pid: 1, name: 'b4', lst: 7 },
 *     { id: 5, pid: 1, name: 'b5', lst: 10 },
 *     { id: 6, pid: 4, name: 'c6', lst: 11 },
 * ];
 *
 * treeStructure(data, 'id', 'pid', 0, 'insertChild', item => {
 *     // 您可以使用自定义callback 也可以借助 recursiveFindKey进行处理
 *     item => recursiveFindKey(item, ['lst'], (source, value, key) => {
 *          if (key === 'lst' && value % 2) {
 *              Reflect.deleteProperty(source, key);
 *          }
 *      })
 * })
 */
var treeStructure = function (source, primaryKey, parentKey, parentValue, childrenKey, callback) {
    if (childrenKey === void 0) { childrenKey = 'children'; }
    var tree = [];
    source.forEach(function (item) {
        if (item[parentKey] === parentValue) {
            var children = exports.treeStructure(source, primaryKey, parentKey, item[primaryKey], childrenKey);
            !exports.isEmptyArray(children) && Reflect.set(item, childrenKey, children);
            callback && callback(item);
            tree.push(item);
        }
    });
    return tree;
};
exports.treeStructure = treeStructure;
